import { ImageField } from '@sitecore-jss/sitecore-jss-nextjs';
import { ItemValue } from 'components/types/ListItem';
import React, { JSX } from 'react';
import { Field } from '@sitecore-jss/sitecore-jss-nextjs';
import { Image } from '@sitecore-jss/sitecore-jss-nextjs';
import { classNames } from 'assets/utils/helper';
import { getMarginSize } from 'assets/utils/getMarginSize';

type IconTextProps = {
  fields: {
    Text: Field<string>;
    Icon: ImageField;
    Alignment: ItemValue;
    Italicize: {
      value: boolean;
    };
    MarginSize: {
      fields: {
        heading: {
          value: string;
        };
      };
    };
  };
};

const IconText = (props: IconTextProps): JSX.Element => {
  const { fields } = props;
  const marginSize = getMarginSize(
    props?.fields?.MarginSize?.fields?.heading?.value
  );
  return (
    <div
    className={classNames('overhauled', marginSize)}
    >
      <div className="jss-inner-container">
        <div
          className={classNames(
            'icon-text',
            fields?.Alignment?.name.toLowerCase(),
            fields?.Italicize?.value ? 'italics' : ''
          )}
        >
          <Image field={fields?.Icon} />
          <p>{fields?.Text?.value}</p>
        </div>
      </div>
    </div>
  );
};

export default IconText;
